import React from "react"
import { Route, BrowserRouter, Routes } from "react-router-dom"

// components
import MainNav from "../components/MainNav"

// pages
import Static from "../pages/Static"
import Homepage from "../pages/Homepage"
// import Faqs from '../pages/Faqs';
import FaqsAPI from "../pages/Faqs_sp"
// import ApartmentListings from '../pages/ApartmentListings';
import ApartmentListingsAPI from "../pages/ApartmentListings_sp"

function Main() {
	const contentOnly =
		window.location.search.indexOf("contentonly") > -1 ? "contentOnly" : ""
	return (
		<section
			id="main"
			className={contentOnly}
		>
			<BrowserRouter>
				<MainNav />

				<Routes>
					<Route
						path="/"
						element={<Homepage />}
					/>
					<Route
						path="/:campus/"
						element={<ApartmentListingsAPI />}
					/>
					<Route
						path="/:campus/faqs"
						element={<FaqsAPI />}
					/>
					<Route
						path="/:campus/apartment-listings"
						element={<ApartmentListingsAPI />}
					/>
					<Route
						path="/static"
						element={<Static />}
					/>
				</Routes>
			</BrowserRouter>
		</section>
	)
}

export default Main
